// extracted by mini-css-extract-plugin
export default {"bg_style":"style_bg_style__eTXmP"};